import { render, staticRenderFns } from "./ModalToRequestInfoAboutRegionalApp.vue?vue&type=template&id=0e1d0f75"
import script from "./ModalToRequestInfoAboutRegionalApp.vue?vue&type=script&lang=js"
export * from "./ModalToRequestInfoAboutRegionalApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports